import { css } from '@emotion/react';

export const media = css`
  img {
    display: block;
    max-width: 100%;
    font-style: italic;
    image-rendering: auto;
  }

  audio,
  canvas,
  iframe,
  svg,
  video {
    vertical-align: middle;
  }

  object,
  video {
    max-width: 100%;
  }
`;
